import React, { useState, useEffect } from 'react';
import { TransitionProvider, TransitionViews } from 'gatsby-plugin-transitions';
import { AnimatePresence, motion } from 'framer-motion';
import Modal from '../../_shared/modal/modal';
import ArmyModal from '../../_shared/modal/armyModal';
import GlobalStyle, { ApplicationWrapper } from './styles/styles';
import SideBar from '../sideBar/sideBar';
import PageTitle from '../pageTitle/pageTitle';
import ScrollTransition, {
  tranistionAnimations,
} from '../scrollTransition/scrollTransition';
import ScrollIcon from '../scrollIcon/scrollIcon';

const Layout = ({ location, path, children }) => {
  const [removeui, setRemoveUI] = useState(true);
  useEffect(() => {
    const introPages = [
      '/pl/',
      '/en/',
      '/fr/',
      '/de/',
      '/ru/',
      '/ua/',
      '/hu/',
      '/',
    ];
    if (introPages.find((el) => el === path)) {
      setRemoveUI(true);
    } else {
      setRemoveUI(false);
    }
  }, [path]);
  return (
    <>
      <GlobalStyle />
      <ApplicationWrapper>
        <TransitionProvider
          location={location}
          mode="immediate"
          {...tranistionAnimations('default')}
        >
          <Modal />
          <ArmyModal />
          <ScrollTransition path={path} />
          {!removeui && (
            <AnimatePresence>
              <SideBar
                path={path}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 1 }}
              />
            </AnimatePresence>
          )}
          {!removeui && (
            <AnimatePresence>
              <PageTitle
                path={path}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 1 }}
              />
            </AnimatePresence>
          )}
          <main>
            <TransitionViews>{children}</TransitionViews>
          </main>
          {!removeui && (
            <AnimatePresence>
              <ScrollIcon
                path={path}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 1 }}
              />
            </AnimatePresence>
          )}
        </TransitionProvider>
      </ApplicationWrapper>
    </>
  );
};

export default Layout;
